import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { default as axios, AxiosResponse } from 'axios';
import { IRootState, IUserState } from './contract';
import { IRootHypermediaRepresentation } from '@/contracts/RootContract';
import { IUserHypermediaRepresentation } from '@/contracts/UserContract';

const exportState: IUserState = {
    user: undefined
};

const mutations: MutationTree<IUserState> = {
    userLoaded(state, payload: IUserHypermediaRepresentation) {
        state.user = payload;
    }
};

const actions: ActionTree<IUserState, IRootState> = {
    async fetchUser({ commit, state, rootState }): Promise<void> {
        if (!state.user) {
            const response: AxiosResponse<IUserHypermediaRepresentation> = await axios.get(
                (rootState.root as IRootHypermediaRepresentation)._links.user.href
            );
            await commit('userLoaded', response && response.data);
        }
    }
};

const getters: GetterTree<IUserState, IRootState> = {};

const namespaced: boolean = true;

export const user: Module<IUserState, IRootState> = {
    namespaced,
    state: exportState,
    getters,
    actions,
    mutations
};
